/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import {
  approveDescription,
  descriptionMasterList,
} from "../../Redux/Actions/MastersApprovalActions";
import { OverlayTrigger } from "react-bootstrap";
import Swal from "sweetalert2";

const DescriptionMaster = ({ selectedTab, ApproveTooltip, DeleteTooltip }) => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortColumnDir, setSortColumnDir] = useState(null);

  const loading = useSelector(
    (state) => state.MastersApproval.descriptionLoading
  );
  const discriptionsList = useSelector(
    (state) => state.MastersApproval.discriptionsList
  );
  const noOfRecords = useSelector(
    (state) => state.MastersApproval.noOfRecordsDiscriptions
  );

  const getAllDiscriptionMasterList = (
    page_number,
    page_size,
    sort_column_name,
    sort_column_dir,
    search_text
  ) => {
    const data = {
      page_number: page_number,
      page_size: page_size,
      sort_column_name: !!sort_column_name ? sort_column_name : null,
      sort_column_dir: !!sort_column_dir ? sort_column_dir : null,
      search_text: !!search_text ? search_text : null,
    };
    dispatch(descriptionMasterList(data));
  };

  const handleSort = (column, sortDirection) => {
    if (Object.keys(column).length !== 0 && !!sortDirection) {
      setSortColumn(column.sortField);
      setSortColumnDir(sortDirection);
      getAllDiscriptionMasterList(
        1,
        perPage,
        column.sortField,
        sortDirection,
        searchText
      );
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
    getAllDiscriptionMasterList(
      page,
      perPage,
      sortColumn,
      sortColumnDir,
      searchText
    );
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
    getAllDiscriptionMasterList(
      page,
      newPerPage,
      sortColumn,
      sortColumnDir,
      searchText
    );
  };

  const approveDescriptionMaster = async (id, is_delete) => {
    const data = {
      id: id,
      is_delete: is_delete,
    };
    Swal.fire({
      title: "Are you sure?",
      html: `You want to ${is_delete ? "delete" : "approve"}!`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#000000",
      cancelButtonColor: "#dd3333",
      confirmButtonText: is_delete ? "Delete" : "Approve",
      customClass: {
        confirmButton: 'confirm-button-swal'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await dispatch(approveDescription(data));
        if (res.payload.result > 0) {
          getAllDiscriptionMasterList(page, perPage, null, null, null);
          Swal.fire({
            title: res?.payload?.message,
            confirmButtonColor: "#000000",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: 'confirm-button-swal'
            }
          })
        } else {
          Swal.fire({
            title: res?.payload?.message,
            confirmButtonColor: "#000000",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: 'confirm-button-swal'
            }
          })
        }
      }
    });
  };

  useEffect(() => {
    if (!!selectedTab && selectedTab === "description") {
      getAllDiscriptionMasterList(page, perPage, null, null, searchText);
    }
  }, [selectedTab, searchText]);

  const customStylesDataTable = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "Bold",
      },
    },
  };

  const columns = [
    {
      name: "Raw Description",
      selector: (row) => row.rawDescriptions,
      sortable: true,
      sortField: "RawDescriptions",
    },
    {
      name: "Description",
      selector: (row) => row.descriptions,
      sortable: true,
      sortField: "Descriptions",
    },
    {
      name: "Action",
      cell: (row) => (
        <>
        <div className={`actions`}>
          <OverlayTrigger placement="top" overlay={ApproveTooltip}>
            <button
              className="btn btn-sm bg-success-subtle"
              onClick={() => approveDescriptionMaster(row.id, false)}
            >
              <i className="bi bi-check2-circle"></i>
            </button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={DeleteTooltip}>
            <button
              className="btn btn-sm bg-danger-subtle ms-2"
              onClick={() => approveDescriptionMaster(row.id, true)}
            >
              <i className="bi bi-trash"></i>
            </button>
          </OverlayTrigger>
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      <DataTable
        columns={columns}
        data={discriptionsList}
        className="table table-bordered table-striped"
        filterServer={true}
        pagination
        paginationServer
        paginationTotalRows={noOfRecords}
        subHeader
        subHeaderComponent={
          <div className="col-md-2">
            <input
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search"
              className="form form-control"
            />
          </div>
        }
        progressPending={loading}
        progressComponent={
          <div style={{ padding: "100px" }}>
            <div className="spinner-border" role="status"></div>
          </div>
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        sortServer
        onSort={handleSort}
        highlightOnHover
        searchableRows={true}
        customStyles={customStylesDataTable}
      />
    </div>
  );
};

export default DescriptionMaster;
